import { GetKurssloeyfeData } from "__generated__/types";
import { ProgressBar } from "common/components/progression/ProgressBar";
import { multipleChoiceFragment } from "domain/multiple-choice/MultipleChoice";
import { ElementPage } from "domain/pages/ElementPage";
import gql from "graphql-tag";
import React from "react";
import { useNavigate, useParams } from "react-router";

export const kurssloeyfeElementsFragment = gql`
  fragment KurssloeyfeElements on Kurssloeyfe {
    elements {
      finished
      id
      content {
        __typename
        id
        status
        title
        context {
          id
          title
        }
        ... on Article {
          youtubeVideoId
          relevantContent {
            content
          }
          body {
            isMarkdown
            content
          }
          canCreateProgression {
            canPerform
          }
        }
        ... on MultipleChoice {
          ...MultipleChoiceData
        }
      }
    }
  }
  ${multipleChoiceFragment}
`;

const DATA_QUERY = gql`
  query GetKurssloeyfeData($containerId: ID!) {
    kurssloeyfeById(id: $containerId) {
      id
      progression {
        finishedContentIds
        allContentIds
      }
      title
      context {
        id
        title
      }
      ...KurssloeyfeElements
      canUpdateDetails {
        canPerform
      }
    }
  }
  ${kurssloeyfeElementsFragment}
`;

export type KurssloeyfeRouteProps = {
  kurssloeyfeId: string;
  kurssloeyfeElementId: string;
};

export const KurssloeyfeElementPage: React.FC = () => {
  const { kurssloeyfeElementId, kurssloeyfeId } =
    useParams<KurssloeyfeRouteProps>();
  const navigate = useNavigate();

  if (!kurssloeyfeId || !kurssloeyfeElementId) {
    navigate("/");
    return <div>Error: Invalid route parameters</div>;
  }

  return (
    <ElementPage<GetKurssloeyfeData>
      containerId={kurssloeyfeId}
      elementId={kurssloeyfeElementId}
      query={DATA_QUERY}
      getData={(it) => it.kurssloeyfeById}
      canCreateProgression={(it) =>
        (it.content.__typename === "Article" ||
          it.content.__typename === "MultipleChoice") &&
        !!it.content.canCreateProgression?.canPerform
      }
      containerType="Kurssloeyfe"
      progress={(props) => (
        <ProgressBar
          progression={props}
          orientation="vertical"
          withSpacing={false}
        />
      )}
    />
  );
};
